import { Component, EventEmitter, input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DialogConfig } from '../dialog/dialog.component';

@Component({
  selector: 'lfe-drawer',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.css'
})
export class DrawerComponent {
  config = input.required<DialogConfig>();

  @Output() actionSelected = new EventEmitter<string>();

  onActionClick(action: string) {
    this.actionSelected.emit(action);
  }

  onBackdropClick() {
    // Close drawer when backdrop is clicked (equivalent to cancel)
    this.actionSelected.emit('cancel');
  }
}
